var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiamond(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 25,
    viewBox: "0 0 30 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 7.33547L5.76142 0.193359H24.8464L29.6078 7.33547L15.3033 24.0004L1 7.33547Z",
    fill: "#00CCFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.16886 7.23933L5.91889 0.616211L3.29297 7.3286L14.3275 22.5794L6.16886 7.23933Z",
    fill: "#00E7FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.82687 4.4945C8.80068 4.33737 6.03906 0.180664 6.03906 0.180664L12.9836 0.285414L8.22217 1.25912L8.82687 4.4945Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.9998 0.841518L4.03337 7.29197L15.1191 22.9428L15.1726 23.0891L1.61328 7.29197L5.94619 0.789062L5.9998 0.841518Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8538 7.13365L15.0204 0.511719L11.9219 7.32886L15.1715 23.6319L13.8538 7.13365Z",
    fill: "#00E7FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4694 23.3353C15.4158 23.0722 10.5234 7.46792 10.5234 7.46792L15.2313 1.1543L12.0483 7.25604L15.4694 23.3353Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4765 0.840469L25.2335 7.29217L15.3583 22.9429L15.3047 23.0893L28.8628 7.29099L24.5299 0.788086L24.4765 0.840469Z",
    fill: "#0055D4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9844 23.3353C15.0379 23.0722 19.9303 7.46792 19.9303 7.46792L15.2224 1.1543L18.4055 7.25604L14.9844 23.3353Z",
    fill: "#0055D4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1 7.33496H4.9115M6.95772 7.33496H9.31819M9.18844 7.33496H29.4756",
    stroke: "#12141A",
    strokeWidth: 0.1,
    strokeLinecap: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5505 7.3511L5.78906 0.208984",
    stroke: "#12141A",
    strokeWidth: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9378 4.76145C21.9648 4.58671 24.8062 0 24.8062 0L17.6641 0.115664L22.561 1.1904L21.9378 4.76145Z",
    fill: "#0055D4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M20.052 7.33468L24.8135 0.192568M10.5352 7.32278L15.2966 0.180664M20.0604 7.35372L15.299 0.211612",
    stroke: "#12141A",
    strokeWidth: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5234 7.33496L15.2849 23.9999L10.5234 7.33496ZM20.0463 7.33496L15.2849 23.9999L20.0463 7.33496Z",
    fill: "#12141A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5234 7.33496L15.2849 23.9999L20.0463 7.33496",
    stroke: "#12141A",
    strokeWidth: 0.2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M7.09104 14.574L6.5661 13.961M5.3067 12.354L1 7.33547L5.76142 0.193359H24.8464L29.6078 7.33547L15.3033 24.0004L8.54208 16.1226",
    stroke: "#12141A",
    strokeWidth: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamond);
export default __webpack_public_path__ + "static/media/Diamond.2c2b274fd914a10ad5848bc27c7192f7.svg";
export { ForwardRef as ReactComponent };